import { useTranslation } from 'react-i18next'
import React from 'react'

import { Title } from '../../../packages/kiti/components/presentation/Text'
import ProjectsGrid from './ProjectsGrid'
import ProjectsListLoader from './_load/ProjectsListLoader'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const ProjectsSection = props => {
  const { t } = useTranslation('projects')
  return (
    <>
      <Title size="h6">{t('project.title')}</Title>

      <Separator weight={2} />

      <ProjectsListLoader>
        <ProjectsGrid />
      </ProjectsListLoader>
    </>
  )
}

export default ProjectsSection
